var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-ads"},[_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[(_vm.img)?_c('figure',{staticClass:"img-area"},[_c('img',{attrs:{"src":_vm.img,"alt":""}})]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }